import React, { useState, useEffect, useRef, useCallback } from "react";
import Image from "../assets/img1.jpg";
import { SignIn, CreateAccount, Tabs, Panel, Verify } from "../components";

import { useDispatch, useSelector } from "react-redux";
import { createAccount } from "../appState/slices/auth/authSlice";
import { useNavigate } from "react-router-dom";
import { setToastMessage } from "../appState/slices/util/utilSlice";
import { toastMessages } from "../constants/toastMessage";
import { updateUserCart } from "../appState/slices/cart/cartSlice";

const Login = () => {
const isInitialized = useRef(false);
  const [otpScreen, setOtpScreen] = useState(false);
  // const [confirmationResult, SetConfirmationResult] = useState();
  const registrationInfo = useSelector((state) => state.auth.registrationInfo);
  const dispatch = useDispatch();
  const otpLength = 4;
  const [phoneNumber, setPhoneNumber] = useState("");
  const navigate = useNavigate();
const [captchaReady, setCaptchaReady] = useState(false);

const handleCaptchaReady = useCallback(() => {
  setCaptchaReady(true);
}, []);  

const user = useSelector((state) => state.auth.user);

  useEffect(() => {
  }, [user]);

useEffect(() => {
  if (!captchaReady) {
    return;
  }

  if (isInitialized.current) {
    return;
  }

  const captchaElement = document.getElementById("msg91-captcha");

  if (!captchaElement) {
    console.error("❌ CAPTCHA container not found");
    return;
  }

  const configuration = {
    widgetId: "366964663332313838363831",
    tokenAuth: process.env.REACT_APP_MSG91_TOKEN,
    exposeMethods: true,
    captchaRenderId: "msg91-captcha",

    success: (data) => {
    },

    failure: (error) => {
      console.error("MSG91 failure:", error);
    },
  };



  const initializeMSG91 = () => {
    if (isInitialized.current) {
      return;
    }

    if (typeof window.initSendOTP !== "function") {
      console.error("❌ MSG91 initSendOTP is not available");
      return;
    }


    window.initSendOTP(configuration);

    isInitialized.current = true;

  };

  const existingScript = document.querySelector(
    'script[src="https://verify.msg91.com/otp-provider.js"]'
  );

  if (existingScript) {

    if (typeof window.initSendOTP === "function") {
      initializeMSG91();
    } else {

      existingScript.addEventListener(
        "load",
        initializeMSG91,
        { once: true }
      );
    }

    return;
  }


  const script = document.createElement("script");

  script.src = "https://verify.msg91.com/otp-provider.js";
  script.async = true;

  script.onload = () => {
    initializeMSG91();
  };

  script.onerror = () => {
    console.error("===== MSG91 SCRIPT FAILED =====");
  };

  document.head.appendChild(script);
}, [captchaReady]);

  const otpVerify = async (otp) => {
    if (otp.length !== otpLength || !otpScreen) return;

    if (!window.verifyOtp) {
      console.error("MSG91 is not initialized yet.");

      dispatch(
        setToastMessage({
          type: toastMessages.TYPE.ERROR,
          message: "OTP service is not ready. Please try again.",
          show: true,
        })
      );

      return;
    }


    window.verifyOtp(
      otp,

      // SUCCESS
      async (data) => {

        const msg91AccessToken = data?.message;

        if (!msg91AccessToken) {
          console.error("MSG91 access token missing:", data);

          dispatch(
            setToastMessage({
              type: toastMessages.TYPE.ERROR,
              message: "OTP verification failed. Please try again.",
              show: true,
            })
          );

          return;
        }

        try {

          const result = await dispatch(
            createAccount({
              registrationInfo,
              accessToken: msg91AccessToken,
            })
          );


          if (result.error) {
            dispatch(
              setToastMessage({
                type: toastMessages.TYPE.ERROR,
                message: result.payload || "User Creation failed",
                show: true,
              })
            );
            navigate("/");
            return;
          }

           dispatch(
              setToastMessage({
                type: toastMessages.TYPE.SUCCESS,
                message: "User created Succesfully",
                show: true,
              })
            );

          const redirectTo =
            localStorage.getItem("redirectAfterLogin") || "/";

          localStorage.removeItem("redirectAfterLogin");

          navigate(redirectTo);

        } catch (error) {
          console.error("Create account error:", error);

          dispatch(
            setToastMessage({
              type: toastMessages.TYPE.ERROR,
              message: "Something went wrong. Please try again.",
              show: true,
            })
          );
        }
      },

      // FAILURE
      (error) => {
        console.error("❌ MSG91 OTP verification failed:", error);

        dispatch(
          setToastMessage({
            type: toastMessages.TYPE.ERROR,
            message: "Invalid OTP. Please try again.",
            show: true,
          })
        );
      }
    );
  };


const handleSendOtp = (number) => {
  if (!window.sendOtp) {
    console.error("MSG91 is not initialized yet.");

    dispatch(
      setToastMessage({
        type: toastMessages.TYPE.ERROR,
        message: "OTP service is not ready. Please try again.",
        show: true,
      })
    );

    return;
  }

  // Check CAPTCHA before sending OTP
  if (typeof window.isCaptchaVerified === "function") {
    const captchaVerified = window.isCaptchaVerified();


    if (!captchaVerified) {
      dispatch(
        setToastMessage({
          type: toastMessages.TYPE.ERROR,
          message: "Please complete the CAPTCHA before requesting OTP.",
          show: true,
        })
      );

      return;
    }
  } else {
    console.error("MSG91 CAPTCHA verification method is not available.");

    dispatch(
      setToastMessage({
        type: toastMessages.TYPE.ERROR,
        message: "CAPTCHA is not ready. Please try again.",
        show: true,
      })
    );

    return;
  }

  const identifier = "91" + number;


  setPhoneNumber(number);

  window.sendOtp(
    identifier,

    (data) => {

      setOtpScreen(true);

      dispatch(
        setToastMessage({
          type: toastMessages.TYPE.SUCCESS,
          message: toastMessages.MESSAGE.OTP_SUCCESS,
          show: true,
        })
      );
    },

    (error) => {
      console.error("MSG91 send OTP error:", error);

      dispatch(
        setToastMessage({
          type: toastMessages.TYPE.ERROR,
          message: toastMessages.MESSAGE.OTP_FAIL,
          show: true,
        })
      );
    }
  );
};

  const handleResendOtp = () => {
    if (!phoneNumber) {
      dispatch(
        setToastMessage({
          type: toastMessages.TYPE.ERROR,
          message: "Phone number not found. Please try again.",
          show: true,
        })
      );

      return;
    }

    if (!window.retryOtp) {
      console.error("MSG91 is not initialized yet.");
      return;
    }

window.retryOtp(
  "11",

  (data) => {

    dispatch(
      setToastMessage({
        type: toastMessages.TYPE.SUCCESS,
        message: toastMessages.MESSAGE.OTP_SUCCESS,
        show: true,
      })
    );
  },

  (error) => {
    console.error("MSG91 resend error:", error);

    dispatch(
      setToastMessage({
        type: toastMessages.TYPE.ERROR,
        message: error.message,
        show: true,
      })
    );
  }
);
  };

  return (
    <div className="login-container">
      <div className="login-left-side">
        <div className="tabs-container">
          <Tabs>
            <Panel title="LOGIN">
              <SignIn />
            </Panel>
            <Panel title="CREATE ACCOUNT">
              {!otpScreen ? (
                <CreateAccount
                  setOtpScreen={setOtpScreen}
                  handleSendOtp={handleSendOtp}
                  onCaptchaReady={handleCaptchaReady}
                />
              ) : (
                <Verify otpVerify={otpVerify} handleResendOtp={handleResendOtp} />
              )}
            </Panel>
          </Tabs>
        </div>
      

      </div>
      <div className="login-right-side">
        <img className="login-image" src="https://purecarats-prod.s3.ap-south-1.amazonaws.com/Purecarats-+Polki+Necklace+Set.png" alt="" />
      </div>
    </div>
  );
};

export default Login;
